document.addEventListener('click', function (event) {
  var desktopNav = document.querySelector('.mpb-desktop-nav');
  if (desktopNav && !desktopNav.contains(event.target)) {
    desktopNav.querySelectorAll('details[open]').forEach(function (detail) {
      detail.removeAttribute('open');
    });
  }

  if (event.target.matches('[data-mpb-overlay], [data-mpb-close]')) {
    var drawer = event.target.closest('[data-mpb-drawer]') || document.querySelector('[data-mpb-drawer][open]');
    if (drawer) drawer.removeAttribute('open');
  }
});

document.addEventListener('click', function (event) {
  var summary = event.target.closest('.mpb-desktop-nav details > summary');
  if (!summary) return;

  var current = summary.parentElement;
  document.querySelectorAll('.mpb-desktop-nav details[open]').forEach(function (detail) {
    if (detail !== current) detail.removeAttribute('open');
  });
});

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-mpb-category-trigger]');
  if (trigger) {
    var explorer = trigger.closest('[data-mpb-category-explorer]');
    if (!explorer) return;
    var key = trigger.getAttribute('data-mpb-category-trigger');

    explorer.querySelectorAll('[data-mpb-category-trigger]').forEach(function (button) {
      var active = button === trigger;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    explorer.querySelectorAll('[data-mpb-category-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-mpb-category-panel') === key);
    });
  }

  var link = event.target.closest('.mpb-mobile-drawer a');
  if (!link) return;
  if (link.getAttribute('href') === '#') {
    event.preventDefault();
    return;
  }
  var drawer = link.closest('[data-mpb-drawer]');
  if (drawer) drawer.removeAttribute('open');
});


function updateMpbPanelOffset() {
  var nav = document.querySelector('.mpb-desktop-nav');
  if (!nav) return;
  var header = nav.closest('.header-wrapper');
  if (!header) return;
  var navRect = nav.getBoundingClientRect();
  var headerRect = header.getBoundingClientRect();
  var offset = Math.max(0, Math.round(headerRect.bottom - navRect.top));
  nav.style.setProperty('--mpb-panel-top', offset + 'px');
}

window.addEventListener('load', updateMpbPanelOffset);
window.addEventListener('resize', updateMpbPanelOffset);
window.addEventListener('scroll', updateMpbPanelOffset, { passive: true });
document.addEventListener('shopify:section:load', updateMpbPanelOffset);
document.addEventListener('shopify:section:reorder', updateMpbPanelOffset);
document.addEventListener('DOMContentLoaded', updateMpbPanelOffset);
